var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "gray",
    stroke: "gray",
    viewBox: "0 0 24 24",
    width: 25,
    height: 25,
    className: "transition-transform transform hover:scale-110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrow);
export default __webpack_public_path__ + "static/media/nextarrow.b27a256320749135b072a2ba4b1b82ad.svg";
export { ForwardRef as ReactComponent };